import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'news-topbar',
  name: '资讯顶栏',
  icon: '讯',
  group: '资讯门户',
  description: '展示新聚浪品牌、定位和搜索入口',
  defaultProps: {
    brandName: '新聚浪',
    location: '徐州',
    searchPlaceholder: '搜你想看的',
    notificationLabel: '消息',
    channels: '推荐,本地,热点,文旅,民生,视频',
    microdramaEnabled: true,
    videoSiteId: 0,
    bannerEnabled: false,
    pinnedEnabled: false
  }
}
